/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Standalone = full-screen brand experience (no DevourPlay chrome), Integrated = wrapped in DevourPlay shell
 * @export
 */
export const ChallengePageMode = {
    STANDALONE: 'STANDALONE',
    INTEGRATED: 'INTEGRATED'
} as const;
export type ChallengePageMode = typeof ChallengePageMode[keyof typeof ChallengePageMode];


export function instanceOfChallengePageMode(value: any): boolean {
    for (const key in ChallengePageMode) {
        if (Object.prototype.hasOwnProperty.call(ChallengePageMode, key)) {
            if (ChallengePageMode[key as keyof typeof ChallengePageMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChallengePageModeFromJSON(json: any): ChallengePageMode {
    return ChallengePageModeFromJSONTyped(json, false);
}

export function ChallengePageModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengePageMode {
    return json as ChallengePageMode;
}

export function ChallengePageModeToJSON(value?: ChallengePageMode | null): any {
    return value as any;
}

export function ChallengePageModeToJSONTyped(value: any, ignoreDiscriminator: boolean): ChallengePageMode {
    return value as ChallengePageMode;
}

